import { AVAILABLE_ENTITIES, Repository, utils } from '../../database'
import { FAZENDA, formatName } from './../../utils/formHelper'
import React, { Component } from 'react'

import Alert from '@mui/material/Alert'
import AppContent from '../../components/layout/AppContent'
import CorralForm from './components/CorralForm'
import Prompt from '../../components/Prompt'
import TitleBar from './../../components/TitleBar'
import TopBar from './../../components/TopBar'
import each from 'lodash/each';
import { getLoggedUser } from '../../redux/auth/actions'
import { recordEvent } from '../../observability/events'
import { verify } from './../../utils/verifyDuplicatePages'
import { withRouter } from '../../utils/withRouterCompat'
class CorralCreate extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorMessage: null
    }

    this.onCancel = this.onCancel.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  onCancel() {
    this.props.history.push(`/farms/${this.props.farm.id}`)
  }

  async onSubmit(payload) {
    const repository = new Repository(AVAILABLE_ENTITIES.CORRALS)
    const result = await this.alredyExist(payload, repository)

    if (result.alredyExist) {
      window.scrollTo(0, 0)

      this.setState({
        errorMessage: result.message
      })

      return
    }

    const createReq = await repository.post(payload)
    if (createReq.success) {
      recordEvent({ level: 'info', category: 'farm', action: 'corral_created', payload: { nome: payload.nome } })
      this.props.history.push(`/farms/${this.props.farm.id}`)
    } else {
      console.error(
        `There was an error trying to create farm: ${createReq.exception}`
      )
    }
  }

  async alredyExist(payload, repository) {
    let corrals = await repository.getByParam('farm_id', this.props.farm.id)
    let verifyCorrals = false

    each(corrals.response, corral => {
      if (corral.nome === payload.nome) {
        verifyCorrals = true
      }
    })

    if (verifyCorrals) {
      return {
        alredyExist: true,
        message: 'Já existe um retiro com esse nome!'
      }
    }
    return { alredyExist: false, message: null }
  }

  getPaths() {
    return [{
      route: `/farms/${this.props.farm.id}`,
      label: formatName(this.props.farm.nome, FAZENDA)
    },
    {
      label: 'Novo Retiro'
    }]
  }

  render() {
    const initialValues = {
      nome: null
    }
    const { errorMessage } = this.state
    return (
      <AppContent>
        <TopBar title={formatName(this.props.farm.nome, FAZENDA)} />
        <TitleBar title='Novo Retiro' paths={this.getPaths()} />
        <Prompt
          visible={verify()}
          title='Página duplicada!'
          message={`Para evitar uma possível perda de dados, não é permitido abrir o Progerar em mais de uma aba!
            Para continuar utilizando, feche esta página e volte para utilizar a anterior.`}
          buttons={[
            {
              autoFocus: false
            },
          ]}
        />
        {errorMessage && (
          <Alert
            severity='error'
            sx={{ width: '100%', mt: 2 }}
          >
            {errorMessage}
          </Alert>
        )}
        <CorralForm
          initialValues={initialValues}
          farm={this.props.farm}
          onCancel={this.onCancel}
          onSubmit={this.onSubmit}
          user={this.props.user}
        />
      </AppContent>
    )
  }
}

const propsFromDatabase = async props => ({
  farm: await utils.getElement(
    AVAILABLE_ENTITIES.FARMS,
    props.match.params.farmId
  ),
  user: await utils.getElement(
    AVAILABLE_ENTITIES.USERS,
    (
      await getLoggedUser()
    ).userId
  )
})

export default utils.withPropsFromDatabase(
  propsFromDatabase,
  withRouter(CorralCreate)
)
